import {
  GET_DESIGNATION,
  ADD_DESIGINATION,
  UPDATE_DESIGNATION,
  DEL_DESIGNATION,
  GET_DEPARTMENT,
  ADD_DEPARTMENT,
  UPDATE_DEPARTMENT,
  DELETE_DEPARTMENT,
  // ---------------
  GET_OFFICELOCATION,
  ADD_OFFICELOCATION,
  UPDATE_OFFICELOCATION,
  DEL_OFFICELOCATION,
  DEL_OFFICELOCATION_ERROR,
  // ----------------
  GET_WORKPRIMISE,
  ADD_WORKPRIMISE,
  UPDATE_WORKPRIMISE,
  DEL_WORKPRIMISE,
  // ---------------
  GET_REWARDS,
  ADD_REWARDS,
  UPDATE_REWARDS,
  DEL_REWADRDS,
  // ---------------
  GET_ASSET,
  ADD_ASSET,
  UPDATE_ASSET,
  DEL_ASSET,
  DEL_ASSET_ITEMS,
  //-----------------
  GET_EMPLOYEETYPE_LIST,
  GET_EMPLOYEETYPES_BY_ID,
  ADD_EMPLOYEETYPE,
  UPDATE_EMPLOYEETYPE,
  DELETE_EMPLOYEETYPE,
  // ---------------
  GET_ITEMS,
  ADD_ITEM,
  UPDATE_ITEM,
  DEL_ITEM,
  //------------------
  GET_LEAVETYPES,
  ADD_LEAVETYPES,
  UPDATE_LEAVETYPES,
  DELETE_LEAVETYPES,
  //---------------
  GET_DUTYYPES,
  ADD_DUTYTYPES,
  UPDATE_DUTYTYPES,
  DELETE_DUTYTYPES,
  //--------------
  GET_COMPANY_PLOICIES,
  ADD_COMPANY_PLOICIES,
  UPDATE_COMPANY_PLOICIES,
  DELETE_COMPANY_PLOICIES,
  //---------------------
  GET_HOLIDAY_CALENDAR,
  ADD_HOLIDAY_CALENDAR,
  UPDATE_HOLIDAY_CALENDAR,
  DELETE_HOLIDAY_CALENDAR,
  // -------------------------
  GET_SKILL,
  // --------------------------
  GET_CERTIFICATIONS,
  ADD_CERTIFICATION,
  UPDATE_CERTIFICATION,
  DELETE_CERTIFICATION,
  //--------------------------
  GET_SKILLCATEGORY,
  ADD_SKILLCATEGORY,
  UPDATE_SKILLCATEGORY,
  DELETE_SKILLCATEGORY,
  DELETE_SKILLCATEGORY_ERROR,
  //--------------------------
  GET_ADMIN_SKILLS,
  ADD_ADMIN_SKILLS,
  UPDATE_ADMIN_SKILLS,
  DELETE_ADMIN_SKILLS,
  //----------------------------
  GET_TECHNOLOGIES,
  ADD_TECHNOLOGY,
  UPDATE_TECHNOLOGY,
  DELETE_TECHNOLOGY,
  //------------------
  GET_REVIEWRATINGS,
  ADD_REVIEWRATINGS,
  UPDATE_REVIEWRATINGS,
  DELETE_REVIEWRATINGS,

  //---------------
  GET_ROLE,
  ADD_ROLE,
  UPDATE_ROLE,
  DELETE_ROLE,

  //---------------
  GET_BEHAVIORALATTRIBUTES,
  ADD_BEHAVIORALATTRIBUTES,
  UPDATE_BEHAVIORALATTRIBUTES,
  DELETE_BEHAVIORALATTRIBUTES,

  //-------------
  GET_POTENTIAL,
  ADD_POTENTIAL,
  UPDATE_POTENTIAL,
  DELETE_POTENTIAL,

  //--------------------
  GET_PRIMARYGOAL,
  ADD_PRIMARY_GOALS,
  UPDATE_PRIMARY_GOALS,
  DELETE_PRIMARY_GOALS,
  GET_GOALS_BY_DESIGNATION,

  //-------------------------------
  GET_ALLAPPRAISAL_QUESTIONS,
  ADD_APPRAISAL_QUESTIONS,
  UPDATE_APPRAISAL_QUESTIONS,
  DELETE_APPRAISAL_QUESTIONS,

  GET_CALENDARYEAR,
  ADD_CALENDARYEAR,
  UPDATE_CALENDARYEAR,
  DELETE_CALENDARYEAR,

  GET_RECANDHOLIDAY_CALENDAR,

  GET_CONFIGUREMAIL,
  CREATE_CONFIGUREMAIL,
  GET_REQUESTTYPE

} from "../actionType";
import { workPrimiseData } from "../../../datas/adminSettings";

// ------------Office Locaton.
export const getOfficeLocation = () => {
  return {
    type: GET_OFFICELOCATION,
  };
};
export const addOfficeLocation = (formData) => {
  return {
    type: ADD_OFFICELOCATION,
    payload: formData,
  };
};
export const updateOfficeLocation = (formData) => {
  return {
    type: UPDATE_OFFICELOCATION,
    payload: formData,
  };
};
export const delOfficeLoation = (delId) => {
  return {
    type: DEL_OFFICELOCATION,
    payload: delId,
  };
};
export const delofficelocationerror = (delId) => {
  return {
    type: DEL_OFFICELOCATION_ERROR,
  };
};

// --------------Designation.
export const getDesignation = () => {
  return {
    type: GET_DESIGNATION,
  };
};
export const addDesignation = (formData) => {
  return {
    type: ADD_DESIGINATION,
    payload: formData,
  };
};
export const updateDesignation = (formData) => {
  return {
    type: UPDATE_DESIGNATION,
    payload: formData,
  };
};
export const delDesignation = (delId) => {
  return {
    type: DEL_DESIGNATION,
    payload: delId,
  };
};

// --------------Department----------//
export const getDepartment = () => {
  return {
    type: GET_DEPARTMENT,
  };
};
export const addDepartment = (formData) => {
  return {
    type: ADD_DEPARTMENT,
    payload: formData,
  };
};
export const updateDepartment = (formData) => {
  return {
    type: UPDATE_DEPARTMENT,
    payload: formData,
  };
};

export const delDepartment = (delId) => {
  return {
    type: DELETE_DEPARTMENT,
    payload: delId,
  };
};

// ----------------Work Primise.
export const getWorkPrimise = () => {
  return {
    type: GET_WORKPRIMISE,
    // payload: workPrimiseData,
  };
};
export const addWorkPrimise = (formData) => {
  return {
    type: ADD_WORKPRIMISE,
    payload: formData,
  };
};
export const updateWorkPrimise = (formData) => {
  return {
    type: UPDATE_WORKPRIMISE,
    payload: formData,
  };
};
export const delWorkPrimise = (delId) => {
  return {
    type: DEL_WORKPRIMISE,
    payload: delId,
  };
};

// ----------------- Rwards.
export const getRewards = () => {
  return {
    type: GET_REWARDS,
  };
};
export const addRewards = (formData) => {
  return {
    type: ADD_REWARDS,
    payload: formData,
  };
};
export const updateRewards = (formData) => {
  return {
    type: UPDATE_REWARDS,
    payload: formData,
  };
};
export const delRewards = (delId) => {
  return {
    type: DEL_REWADRDS,
    payload: delId,
  };
};

// ----------------Asset.
export const getAllAsset = () => {
  return {
    type: GET_ASSET,
  };
};
export const addAsset = (formData) => {
  return {
    type: ADD_ASSET,
    payload: formData,
  };
};
export const updateAsset = (formDate) => {
  return {
    type: UPDATE_ASSET,
    payload: formDate,
  };
};
export const delAsset = (delId) => {
  return {
    type: DEL_ASSET,
    payload: delId,
  };
};
export const delAssetItem = (delId) => {
  return {
    type: DEL_ASSET_ITEMS,
    payload: delId,
  };
};

//-------------Employee Type----------//

export const getEmployeeTypeList = () => {
  return {
    type: GET_EMPLOYEETYPE_LIST,
  };
};

export const getEmployeeTypeById = () => {
  return {
    type: GET_EMPLOYEETYPES_BY_ID,
  };
};
export const addEmployeeType = (formData) => {
  return {
    type: ADD_EMPLOYEETYPE,
    payload: formData,
  };
};
export const updateEmployeeType = (formData) => {
  return {
    type: UPDATE_EMPLOYEETYPE,
    payload: formData,
  };
};

export const delEmployeeType = (delId) => {
  return {
    type: DELETE_EMPLOYEETYPE,
    payload: delId,
  };
};

// -------------- Item Action

export const getItemsList = () => {
  return {
    type: GET_ITEMS,
  };
};

export const addItem = (itemformData) => {
  return {
    type: ADD_ITEM,
    payload: itemformData,
  };
};

export const updateItems = (itemformData) => {
  return {
    type: UPDATE_ITEM,
    payload: itemformData,
  };
};

export const delItem = (delId) => {
  return {
    type: DEL_ITEM,
    payload: delId,
  };
};

//-------------Leave Types----------//
export const getLeaves = () => {
  return {
    type: GET_LEAVETYPES,
  };
};
export const addLeaves = (formData) => {
  return {
    type: ADD_LEAVETYPES,
    payload: formData,
  };
};
export const updateLeaves = (formData) => {
  return {
    type: UPDATE_LEAVETYPES,
    payload: formData,
  };
};

export const delLeaves = (formData) => {
  return {
    type: DELETE_LEAVETYPES,
    payload: formData,
  };
};

//-------------DUTY Types----------//
export const getDuty = () => {
  return {
    type: GET_DUTYYPES,
  };
};
export const addDuty = (formData) => {
  return {
    type: ADD_DUTYTYPES,
    payload: formData,
  };
};
export const updateDuty = (formData) => {
  return {
    type: UPDATE_DUTYTYPES,
    payload: formData,
  };
};

export const delDuty = (delId) => {
  return {
    type: DELETE_DUTYTYPES,
    payload: delId,
  };
};

//------------Company Ploicies----------//
export const getCompanyPolicies = () => {
  return {
    type: GET_COMPANY_PLOICIES,
  };
};
export const addCompanyPolicies = (formData) => {
  return {
    type: ADD_COMPANY_PLOICIES,
    payload: formData,
  };
};
export const updateCompanyPolicies = (formData) => {
  return {
    type: UPDATE_COMPANY_PLOICIES,
    payload: formData,
  };
};

export const delCompanyPolicies = (delId) => {
  return {
    type: DELETE_COMPANY_PLOICIES,
    payload: delId,
  };
};

//------------Holiday Calendar----------//
export const getCalendar = () => {
  return {
    type: GET_HOLIDAY_CALENDAR,
  };
};
export const addCalendar = (formData) => {
  return {
    type: ADD_HOLIDAY_CALENDAR,
    payload: formData,
  };
};
export const updateCalendar = (formData) => {
  return {
    type: UPDATE_HOLIDAY_CALENDAR,
    payload: formData,
  };
};

export const delCalendar = (delId) => {
  return {
    type: DELETE_HOLIDAY_CALENDAR,
    payload: delId,
  };
};
export const getRecHolidayCalendar = () => {
  return {
    type: GET_RECANDHOLIDAY_CALENDAR,
  };
};
// ---------------- Skill --------------- //
export const getSkill = () => {
  return {
    type: GET_SKILL,
  };
};

// --------------- Certification ----------- //
export const getAllCertifications = () => {
  return {
    type: GET_CERTIFICATIONS,
  };
};
export const addCertification = (formData) => {
  return {
    type: ADD_CERTIFICATION,
    payload: formData,
  };
};
export const updateCertification = (formData) => {
  return {
    type: UPDATE_CERTIFICATION,
    payload: formData,
  };
};

export const delCertification = (delId) => {
  return {
    type: DELETE_CERTIFICATION,
    payload: delId,
  };
};

// --------------Admin Skills----------//
export const getAdminSkill = () => {
  return {
    type: GET_ADMIN_SKILLS,
  };
};
export const addAdminSkill = (formData) => {
  return {
    type: ADD_ADMIN_SKILLS,
    payload: formData,
  };
};
export const updateAdminSkill = (formData) => {
  return {
    type: UPDATE_ADMIN_SKILLS,
    payload: formData,
  };
};

export const delAdminSkill = (delId) => {
  return {
    type: DELETE_ADMIN_SKILLS,
    payload: delId,
  };
};
// --------------Skill Category----------//
export const getSkillCategory = () => {
  return {
    type: GET_SKILLCATEGORY,
  };
};
export const addSkillCategory = (formData) => {
  return {
    type: ADD_SKILLCATEGORY,
    payload: formData,
  };
};
export const updateSkillCategory = (formData) => {
  return {
    type: UPDATE_SKILLCATEGORY,
    payload: formData,
  };
};

export const delSkillCategory = (delId) => {
  return {
    type: DELETE_SKILLCATEGORY,
    payload: delId,
  };
};
export const delErrorSkillCategory = (delId) => {
  return {
    type: DELETE_SKILLCATEGORY_ERROR,
  };
};
// --------------Technologies----------//
export const getTechnology = () => {
  return {
    type: GET_TECHNOLOGIES,
  };
};
export const addTechnology = (formData) => {
  return {
    type: ADD_TECHNOLOGY,
    payload: formData,
  };
};
export const updateTechnology = (formData) => {
  return {
    type: UPDATE_TECHNOLOGY,
    payload: formData,
  };
};

export const delTechnology = (delId) => {
  return {
    type: DELETE_TECHNOLOGY,
    payload: delId,
  };
};

//-------------Rating Review----------//
export const getReviewList = () => {
  return {
    type: GET_REVIEWRATINGS,
  };
};
export const addReviewRating = (formData) => {
  return {
    type: ADD_REVIEWRATINGS,
    payload: formData,
  };
};
export const updateReviewRating = (formData) => {
  return {
    type: UPDATE_REVIEWRATINGS,
    payload: formData,
  };
};

export const delReviewRating = (delId) => {
  return {
    type: DELETE_REVIEWRATINGS,
    payload: delId,
  };
};

//-------------Behaioral Attribute----------//

export const getBehavioralAttribute = () => {
  return {
    type: GET_BEHAVIORALATTRIBUTES,
  };
};

export const addBehavioralAttribute = (formData) => {
  return {
    type: ADD_BEHAVIORALATTRIBUTES,
    payload: formData,
  };
};
export const updateBehavioralAttribute = (formData) => {
  return {
    type: UPDATE_BEHAVIORALATTRIBUTES,
    payload: formData,
  };
};

export const delBehavioralAttribute = (delId) => {
  return {
    type: DELETE_BEHAVIORALATTRIBUTES,
    payload: delId,
  };
};

//-------------Appraisee Potential----------//

export const getPotential = () => {
  return {
    type: GET_POTENTIAL,
  };
};

export const addPotential = (formData) => {
  return {
    type: ADD_POTENTIAL,
    payload: formData,
  };
};
export const updatePotential = (formData) => {
  return {
    type: UPDATE_POTENTIAL,
    payload: formData,
  };
};

export const delPotential = (delId) => {
  return {
    type: DELETE_POTENTIAL,
    payload: delId,
  };
};

//-------------Role----------//
export const getRole = () => {
  return {
    type: GET_ROLE,
  };
};
export const addRole = (formData) => {
  return {
    type: ADD_ROLE,
    payload: formData,
  };
};
export const updateRole = (formData) => {
  return {
    type: UPDATE_ROLE,
    payload: formData,
  };
};

export const delRole = (delId) => {
  return {
    type: DELETE_ROLE,
    payload: delId,
  };
};

export const getAllGoals =()=>{
  return {
    type:GET_PRIMARYGOAL,
  }
};
export const GetGoalsByDesignation = (designationId) => {
  return {
    type: GET_GOALS_BY_DESIGNATION,
    payload : designationId
  };
};
export const addPrimayGoals = (formData) => {
  return {
    type: ADD_PRIMARY_GOALS,
    payload: formData,
  };
};
export const updatePrimayGoals = (formData) => {
  return {
    type: UPDATE_PRIMARY_GOALS,
    payload: formData,
  };
};

export const delPrimayGoals = (formData) => {
  return {
    type: DELETE_PRIMARY_GOALS,
    payload:formData,
  };
};


export const addAppraisalquestions = (formData) => {
  return {
    type: ADD_APPRAISAL_QUESTIONS,
    payload: formData,
  };
};
export const updateAppraisalquestions = (formData) => {
  return {
    type: UPDATE_APPRAISAL_QUESTIONS,
    payload: formData,
  };
};

export const delAppraisalquestions = (delId) => {
  return {
    type: DELETE_APPRAISAL_QUESTIONS,
    payload: delId,
  };
};



//-------------Calendar Year----------//
export const getCalendarYearList = () => {
  return {
    type: GET_CALENDARYEAR,
  };
};
export const addCalendarYear = (formData) => {
  return {
    type: ADD_CALENDARYEAR,
    payload: formData,
  };
};
export const updateCalendarYear = (formData) => {
  return {
    type: UPDATE_CALENDARYEAR,
    payload: formData,
  };
};

export const delCalendarYear = (delId) => {
  return {
    type: DELETE_CALENDARYEAR,
    payload: delId,
  };
};

//-------------Configure mail----------//
export const getConfiguremail = () => {
  return {
    type: GET_CONFIGUREMAIL,
  };
};
export const addconfiguremail = (formData) => {
  return {
    type: CREATE_CONFIGUREMAIL,
    payload: formData,
  };
};
export const getRequesttype = () => {
  return {
    type: GET_REQUESTTYPE,
  };
};